module.exports = __webpack_public_path__ + "static/media/twitter.d7c6644a.png";